export default class SplitModule {
  constructor(component) {
    this.dom = {
      $component: component,
      $modules: component.querySelectorAll('.js-overlay')
    }
    this.state = {

    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$modules.forEach($module => $module.addEventListener('click', this.redirect))
  }

  redirect(e) {
    const module = e.target.closest('.js-overlay')
    const link = module.querySelector('.js-link')
    window.location.href = link.href
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ImageLinkSlider = this
  }
}
